enum BenchmarkingDashboardDetailsTypeEnum {
  None = 0,
  NetworkDrillin = 1,
  VennDiagramPrimaryOnly = 2,
  VennDiagramCommon = 3,
  VennDiagramComparisonOnly = 4,
  OverlapInNetwork = 5,
  OverlapOutNetwork = 6,
  NetworkInMarketDrillin = 7,
  MarketOutOfNetworkDrillin = 8,
  NetworkOutOfMarketDrillin = 9,
  Affiliations = 10
}

export { BenchmarkingDashboardDetailsTypeEnum };